
export const footerTranslations = {
  about: {
    fr: "À propos",
    en: "About"
  },
  contact: {
    fr: "Contactez-nous",
    en: "Contact us"
  },
  rights: {
    fr: "Tous droits réservés.",
    en: "All rights reserved."
  },
  legal: {
    fr: "Mentions légales",
    en: "Legal mentions"
  },
  privacy: {
    fr: "Politique de confidentialité",
    en: "Privacy policy"
  }
};
